<div id="export-data-map">
</div>

<div #tooltip [hidden]="true">
  <mpro-tooltip [options]="mapTooltip"></mpro-tooltip>
</div>
